export default __webpack_public_path__ + "72c36384be41de983c57e364ab0002a3.png";